import Component from '@glimmer/component';
import { isPresent } from '@ember/utils';
import ContactModel from 'donor-elf-web/models/contact';

interface ComponentArgs {
  contact: ContactModel;
}

export default class ContactMoreInfoDropdownComponent extends Component<ComponentArgs> {
  get contactMailingNameOrName() {
    return isPresent(this.args.contact.mailingName)
      ? this.args.contact.mailingName
      : this.args.contact.name;
  }
}
